import { TreeSelect } from '@formily/antd';
import { createSchemaComponent } from '../../shared';
export default createSchemaComponent({
    componentName: 'TreeSelect',
    component: TreeSelect,
});
